module.exports = __webpack_public_path__ + "img/clue4_light.c13efb6c.png";